<template>
  <div class="ql-container ql-snow" style="border: 0px;">
    <div class="ql-editor" style="padding-left: 8px; padding-right: 8px;" v-html="randerContent"></div>
  </div>
</template>
<script>
import HtmlDiff from 'htmldiff-js'

export default {
  props: {
    oldContent: {
      type: String,
      default: ''
    },
    newContent: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  methods: {},
  computed: {
    randerContent() {
      let diffHTML = HtmlDiff.execute(this.oldContent, this.newContent)
      diffHTML = diffHTML.replace(/<ins class="diffmod">([\s\S]*?)<\/ins>/g, '<div class="insDiff">$1</div>')
      // diffHTML = diffHTML.replace(/<ins class="diffins">([\s\S]*?)<\/ins>/g, '<span class="insSpanDiff">$1</span>')
      diffHTML = diffHTML.replace(/<ins class="diffins">([\s\S]*?)<\/ins>/g, '<div class="insDiff">$1</div>')
      diffHTML = diffHTML.replace(/<del class="diffmod">([\s\S]*?)<\/del>/g, '<div class="delDiff">$1</div>')
      // diffHTML = diffHTML.replace(/<del class="diffdel">([\s\S]*?)<\/del>/g, '<span class="delSpanDiff">$1</span>')
      diffHTML = diffHTML.replace(/<del class="diffdel">([\s\S]*?)<\/del>/g, '<div class="delDiff">$1</div>')

      // 匹配并替换 <img> 标签
      diffHTML = diffHTML.replace(/<img([\s\S]*?)>/g, '<div class="diffImg"><img$1 /></div>')

      return diffHTML
    }
  }
}
</script>
<style lang="less">
.delSpanDiff {
  background-color: rgba(255, 0, 0, 0.3);
}
.delDiff {
  display: inline;
  position: relative;
  background-color: rgba(255, 0, 0, 0.3);

  /* 当子元素是图片时，设置为块级元素 */
  .diffImg {
    display: block;
    position: relative;

    /* 确保伪元素有内容 */
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 0, 0, 0.3);
      /* 确保伪元素在父元素之上 */
      z-index: 1;
    }
  }
}

.insSpanDiff {
  // color: #fff;
  // background-color: rgb(0, 200, 0);

  background-color: rgba(0, 255, 0, 0.3);
}
.insDiff {
  display: inline;
  position: relative;
  background-color: rgba(0, 255, 0, 0.3);

  /* 当子元素是图片时，设置为块级元素 */
  .diffImg {
    display: block;
    position: relative;

    /* 确保伪元素有内容 */
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 255, 0, 0.3);
      /* 确保伪元素在父元素之上 */
      z-index: 1;
    }
  }
}
</style>
